import React from 'react';

import Menu, { MenuProps } from './Menu';
import NoAutocompleteResults from './NoAutocompleteResults';

export type AutocompleteMenuProps = MenuProps;

/**
 * @deprecated Use Menu instead
 * This menu adds the empty state for an autocomplete dropdown when no results are found
 */
const AutocompleteMenu = React.forwardRef<
  HTMLUListElement,
  AutocompleteMenuProps
>(({ children, ...props }, ref) => {
  const content =
    React.Children.toArray(children).length > 0 ? (
      children
    ) : (
      <NoAutocompleteResults />
    );
  return (
    <Menu ref={ref} {...props}>
      {content}
    </Menu>
  );
});

AutocompleteMenu.displayName = 'AutocompleteMenu';

AutocompleteMenu.propTypes = Menu.propTypes;

export default AutocompleteMenu;
